/* @flow */
/** @jsx h */
import { Component, h, VNode } from 'preact';
import styles from './index.css';
import cn from 'classnames';
import { RootStore } from '../../js/stores/root.store';
type Props = {
  src?: string;
  mediaType?: string;
  videoCurrentTime: number;
  children?: VNode;
  renderType: string;
};

type State = {};

class EndScreenVideo extends Component<Props, State> {
  private videoRef: HTMLVideoElement | null = null;

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {
    if (this.videoRef && !isNaN(this.props.videoCurrentTime)) {
      this.videoRef.currentTime = this.props.videoCurrentTime;
    }
  }

  componentDidUpdate() {
    if (this.videoRef && !isNaN(this.props.videoCurrentTime)) {
      this.videoRef.currentTime = this.props.videoCurrentTime;
    }
  }

  render() {
    const isVideoCompleted = RootStore.getInstance().videoStore.isVideoCompleted
      .value;
    const { children, src, mediaType, renderType } = this.props;

    return (
      <div
        className={cn({
          [styles.backgroundVideoContainer]: true,
          [styles.backgroundVideoContainerMPU]: renderType === 'MPU',
          [styles.backgroundVideoContainerFullScreen]:
            renderType === 'fullScreen'
        })}
        id="end_screen_default"
      >
        <video
          ref={ref => (this.videoRef = ref)}
          id="endscreen-video"
          preload={'auto'}
          className={cn({
            [styles.backgroundVideo]: true,
            [styles.backgroundVideoMPU]: renderType === 'MPU',
            [styles.backgroundVideoFullScreen]: renderType === 'fullScreen',
            [styles.backgroundVideoDisplayed]: isVideoCompleted
          })}
          muted={true}
          playsinline={true}
        >
          <source src={src} type={mediaType} />
        </video>
        {children}
      </div>
    );
  }
}

export default EndScreenVideo;
